import React, { useState } from 'react'
import "./Footer.scss"
import { useSelector } from 'react-redux'
import { FormattedMessage } from "react-intl";
import { Link } from 'react-router-dom'
import { create } from '../../../../api/contacts'
import { CONTACTS_LIST_IDS } from '../../../../utils/constants'


function Footer() {
  const lang = useSelector((store) => store.intl.currentLocale)
  const [email, setEmail] = useState('')
  const [error, setError] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)

  async function subscribe() {
    setError(false)
    setIsSuccess(false)
    if (!email) {
      setError(true)
      return
    }
    try {
      await create({ email, listIds: CONTACTS_LIST_IDS['subscriber'][lang]})
      setError(false)
      setIsSuccess(true)
      setEmail('')
    } catch (error) {
      const {response = {}} = await error
      const errorText = JSON.parse(response?.text)
      if (errorText.message === "Invalid email address") {
        setError(true)
      } else if(errorText.message === "Contact already in list and/or does not exist") {
        setError("already-exists")
      }
    }
  }

  return (
      <footer id="footer">
          <div className="left">
            <div className="info-wrapper">
              <div className="contact">
                <p className="bold-white">
                <FormattedMessage id="home.footer.company" />
                </p>
                <p className="info">QRcards s.r.o.</p>
                <p className="info">ID 07376367, VAT ID CZ07376367</p>
                <p className="info">support@QRcards.com</p>
              </div>
              <div className="socials">
                <p className="bold-white"><FormattedMessage id="home.footer.socials" /></p>
                <div><img src="assets/icons/footer-facebook.svg" alt="" /><a href="https://www.facebook.com/QRcardsapp" target="_blank" rel="noopener noreferrer">Facebook</a></div>
                <div><img src="assets/icons/footer-instagram.svg" alt="" /><a href="https://www.instagram.com/qrcards" target="_blank" rel="noopener noreferrer">Instagram</a></div>
                <div><img src="assets/icons/footer-linkedin.svg" alt="" /><a href="https://www.linkedin.com/company/qrcardsapp" target="_blank" rel="noopener noreferrer">Linkedin</a></div>
              </div>
            </div>
            <div className="privacy-policies mobile">
              <Link to={`/privacy-policy`}><p><FormattedMessage id="home.footer.privacyPolicy" /></p></Link>
              <Link to={`/conditions-of-use`}><p><FormattedMessage id="home.footer.conditionsOfUse" /></p></Link>
              <Link to={`/terms-of-use`}><p><FormattedMessage id="home.footer.termsOfUse" /></p></Link>
            </div>
            <div className='copyright'>
              <p className='name'>QR Cards</p>
              <p>Copyright - All rights reserved. <FormattedMessage id="home.footer.trademarkText" /></p>
            </div>
          </div>
          <div className="right">
            <div className="wrapper">
              <div className="input-wrapper">
                <p className='bold-white'><FormattedMessage id="home.footer.subscribe" /></p>
                <span className="agreement">
                <FormattedMessage
                  id="home.footer.agreement"
                  values={{
                    a: (chunks) => <Link to="/privacy-policy" target="_blank">{chunks}</Link>
                  }}
                />
                </span>
                <div className="email-wrapper">
                  <FormattedMessage id="home.footer.email">
                    {(msg) => (<input placeholder={msg} type="text" value={email} onChange={(e) => setEmail(e.target.value)} />)}
                  </FormattedMessage>
                  <img onClick={() => subscribe()} src="assets/icons/footer-plane.svg" alt="" />
                </div>
                <div className="messages-wrapper">
            {error === "already-exists" ?
            <span className="messages-wrapper__success"><FormattedMessage id="home.form.existing" /></span>: error?
            <span className="messages-wrapper__error"><FormattedMessage id="home.form.wrongEmail" /></span> : <></>}
            {!error && isSuccess &&
            <span className="messages-wrapper__success"><FormattedMessage id="home.form.newsLetter" /></span>}
          </div>
              </div>
              <div onClick={() => {document.body.scrollTop = 0;document.documentElement.scrollTop = 0}} className="button-wrapper">
                <button className='white-circle'>
                  <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.39588 12.0664L4.39588 4.62118" stroke="#38517C" strokeWidth="1.20371" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.4082 4.91895L4.39584 0.451813L0.383478 4.91895L8.4082 4.91895Z" fill="#38517C" />
                  </svg>
                </button>
                <p className="bold-white">
                <FormattedMessage id="home.footer.scrollUp" />
                </p>
              </div>
            </div>
            <div className="privacy-policies default">
              <Link to={`/privacy-policy`}><p><FormattedMessage id="home.footer.privacyPolicy" /></p></Link>
              <Link to={`/conditions-of-use`}><p><FormattedMessage id="home.footer.conditionsOfUse" /></p></Link>
              <Link to={`/terms-of-use`}><p><FormattedMessage id="home.footer.termsOfUse" /></p></Link>
            </div>
          </div>
        </footer>
  )
}

export default Footer
